import axios, { AxiosResponse } from 'axios';
import {
  ChangePasswordProps,
  CompanyDtlApiRes,
  DivisionDtlApiRes,
  DivisionReqProps,
  ForgotPasswordProps,
  ForgotPasswordResponse,
  LoginProps,
  LoginResponse,
  changeCurrentPasswordReq,
  changeCurrentPasswordRes,
} from './types';
import {
  CHANGE_CURRENT_PASSWORD_URL,
  CHANGE_PASSWORD_URL,
  FORGOT_PASSWORD_PIN_URL,
  FORGOT_PASSWORD_URL,
  GET_USER_COMPANY_URL,
  GET_USER_DIVISION_URL,
  LOGIN_API_URL,
  LOGIN_WITH_PIN_URL,
  SET_USER_PIN_URL,
  GET_USER_PREF_CONFIG_URL,
} from './constants';
import { MutateFunction, MutationFunction } from '@tanstack/react-query';

export const login: MutationFunction<
  AxiosResponse<LoginResponse>,
  LoginProps
> = async (payload: LoginProps) => {
  try {
    const response = await axios.post<LoginResponse>(LOGIN_API_URL, payload);
    return response;
  } catch (error: any) {
    throw new Error(error.response?.data.message);
  }
};

export const loginWithPin: MutateFunction<
  AxiosResponse<LoginResponse>,
  Error,
  Partial<LoginProps>
> = async (payload: Partial<LoginProps>) => {
  try {
    const response = await axios.post<LoginResponse>(
      LOGIN_WITH_PIN_URL,
      payload
    );
    return response;
  } catch (error: any) {
    throw new Error(error.response?.data.message);
  }
};

export const setUserPin = async (
  payload: any
): Promise<AxiosResponse<LoginResponse>> => {
  try {
    const response = await axios.post<LoginResponse>(SET_USER_PIN_URL, payload);
    return response;
  } catch (error: any) {
    throw new Error(error.response?.data.message);
  }
};
export const getCompanyDtl = async (): Promise<
  AxiosResponse<CompanyDtlApiRes>
> => {
  try {
    const response = await axios.get<CompanyDtlApiRes>(GET_USER_COMPANY_URL);
    return response;
  } catch (error: any) {
    throw new Error(error.response?.data.message);
  }
};
export const getDivisionDtl = async (
  payload: DivisionReqProps
): Promise<AxiosResponse<DivisionDtlApiRes>> => {
  try {
    const response = await axios.post<DivisionDtlApiRes>(
      GET_USER_DIVISION_URL,
      payload
    );

    return response;
  } catch (error: any) {
    throw new Error(error.response?.data?.message);
  }
};

export const forgotPassword: MutationFunction<
  AxiosResponse<ForgotPasswordResponse>,
  ForgotPasswordProps
> = async (payload: ForgotPasswordProps) => {
  try {
    const response = await axios.post<ForgotPasswordResponse>(
      FORGOT_PASSWORD_URL,
      payload
    );
    return response;
  } catch (error: any) {
    throw new Error(error.response?.data.message);
  }
};
export const ResetPassword: MutationFunction<
  AxiosResponse<ForgotPasswordResponse>,
  ChangePasswordProps
> = async (payload: ChangePasswordProps) => {
  try {
    const response = await axios.post<ForgotPasswordResponse>(
      CHANGE_PASSWORD_URL,
      payload
    );
    return response;
  } catch (error: any) {
    throw new Error(error.response?.data.message);
  }
};
export const verifyForgotPasswordPin = async (
  payload: any
): Promise<AxiosResponse<LoginResponse>> => {
  try {
    const response = await axios.post<LoginResponse>(
      FORGOT_PASSWORD_PIN_URL,
      payload
    );
    return response;
  } catch (error: any) {
    throw new Error(error.response?.data.message);
  }
};

export const changeCurrentPassword = async (
  payload: changeCurrentPasswordReq
): Promise<AxiosResponse<changeCurrentPasswordRes>> => {
  try {
    const response = await axios.post<changeCurrentPasswordRes>(
      CHANGE_CURRENT_PASSWORD_URL,
      payload
    );
    return response;
  } catch (error: any) {
    throw new Error(error.response?.data.message);
  }
};

export const getUserPrefConfig = async (): Promise<AxiosResponse<any>> => {
  try {
    const response = await axios.get<any>(GET_USER_PREF_CONFIG_URL);
    return response;
  } catch (error: any) {
    throw new Error(error.response?.data.message);
  }
};
